import { Td, Text, Tooltip, Tr, useToast } from "@chakra-ui/react"
import { firstLetterUpperCaseAndRestLowerCase } from "../../../utils/capitalFirstLetter"
import React, { Suspense } from "react"
import { AprovarRetificacao } from "./components/AprovarRetificacao"
import { RecusarRetificacao } from "./components/RecusarRetificacao"

export function List({ item }) {
  return (
    <Tr>
      <Td textAlign={"center"}>{item.codprod}</Td>
      <Td textAlign={"center"}>{item.nome_vendedor}</Td>
      <Td textAlign={"center"}>{item.numero_pedido}</Td>
      <Tooltip label={item.original_obs} aria-label="A tooltip">
        <Td textAlign={"center"}>{item.observacao}</Td>
      </Tooltip>
      <Td textAlign={"center"}>
        <Text
          as={"a"}
          href={item.link_layout}
          target="_blank"
          color={item.link_layout === "" ? "red.500" : "blue.500"}
          _hover={{
            filter: "brightness(0.8)",
            textDecoration: "underline",
          }}
          cursor={"pointer"}
          textAlign={"center"}
        >
          Link Layout
        </Text>
      </Td>
      <Td textAlign={"center"} display="flex" alignItems="center" justifyContent="center" gap={2}>
        <AprovarRetificacao item={item} />
        <RecusarRetificacao item={item} />
      </Td>
    </Tr>
  )
}
